import BaseComponent from '../base/baseComponent';
export default class GetBeIren extends BaseComponent {
    constructor(element) {
        super(element);
        let fidelityPoints = this._options.fidelityPoints;
        this.setBeIrenMessage(fidelityPoints);
    }
    async setBeIrenMessage(fidelityPoints) {
        let beIrenMessage;
        let pageDiv = document.querySelector('.page');
        //@ts-ignore
        let getBeIren = pageDiv.dataset.getBeIrenUrl + '?fidelityPoints=' + fidelityPoints;
        try {
            beIrenMessage = await fetch(getBeIren).then((r) => r.json());
        }
        catch (e) {
            console.error(e);
            return;
        }
        let fidelityText = document.querySelector('.fidelity-text');
        fidelityText.innerText = beIrenMessage.beIren;
    }
}
